import React, { useState } from "react";
import axios from "axios"
import "../Account.css"
// import { FaGooglePlusG } from "react-icons/fa";
// import { useGoogleLogin } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
// import Google from "../../image/google.png"

function GoogleSignup() {
    const [error, setError] = useState('')
    // const [firstName, setFirstName] = useState('')
    // const [lastName, setLastName] = useState('')
    // const [email, setEmail] = useState('')
    // const [accessToken, setAccessToken] = useState('')
    // const login = useGoogleLogin({
    //     onSuccess: (tokenResponse) => {
    //         console.log('Google login success:', tokenResponse); // Log the entire response
    //         if (tokenResponse && tokenResponse.credential) {
    //           console.log('Credential:', tokenResponse.credential);
    //         } else {
    //           console.log('Credential not found in response.');
    //         }
    //       },
    //       onError: (error) => {
    //           console.log("Google Login Error:", error);
    //       },
    //       flow: 'implicit',
    //});
    // onSuccess: async (response) => {
    //     console.log(response)
    //     console.log("Access token type:", typeof response.access_token); // Check the type
    //     console.log("Access token:", response.access_token);
    //     console.log("response.credential", response.credential)
    //     console.log("response.id_token", response.id_token)
    //     try {
    //         const responses = await axios.post("https://api.geoinfoacademy.com/dj-rest-auth/google/", {
    //             headers: {
    //                 Authorization: `Bearer ${response.access_token}`
    //             },
    //         }
    //         );
    //         console.log("Registration successful!");
    //         const accessToken = responses.data['access'];
    //         const userData = responses.data['user'];
    //         localStorage.setItem('accessToken', accessToken);
    //         localStorage.setItem('user', JSON.stringify(userData));
    //         console.log('Redirecting to dashboard');
    //         window.location.href = '/dashboard';

    //     } catch (apiError) {
    //         console.error("Registration failed:", apiError);
    //         setError("Registration failed")
    //         setTimeout(() => {
    //             setError('');
    //         }, 5000);
    //     }

    // try{
    //     const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo",
    //     {
    //         headers:{
    //             Authorization: `Bearer ${response.access_token}`,
    //         },
    //     });
    //     console.log(res)
    //     console.log(res.data.given_name)
    //     setFirstName(res.data.given_name);
    //     setLastName(res.data.family_name)
    //     setEmail(res.data.email)
    //     setAccessToken(response.access_token)
    //     // setPicture(res.data.picture)
    //     console.log("checking the data",firstName, lastName , email, accessToken )



    // }
    // catch(err){
    //     console.log(err);
    //     setError(err)
    // }


    // useEffect(() => {
    //     if (firstName || email || lastName || accessToken) {
    //         console.log("checking the data", firstName, email, lastName, accessToken);
    //     }
    // }, [firstName, email, lastName, accessToken]); 
    // const handleGoogleSignup = (event) => {
    //     event.preventDefault();
    //     login();
    // };
    const onSuccess = async (credentialResponse) => {
        try {
            const response = await axios.post(
                "https://api.geoinfoacademy.com/dj-rest-auth/google/",
                { access_token: credentialResponse.credential } // Correct payload structure
            );

            console.log("Registration successful!", response);
            const accessToken = response.data.access;
            const userData = response.data.user;

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('user', JSON.stringify(userData));
            console.log('Redirecting to dashboard');
            const course_id = localStorage.getItem("redirectCourseId")
            if (course_id) {
                localStorage.removeItem('redirectCourseId');
                window.location.href = `/description/${course_id}/paymentverify`
            } else {
                window.location.href = '/dashboard';
            }
        } catch (apiError) {
            console.error("Registration failed:", apiError);
            setError("Registration failed");
            setTimeout(() => {
                setError('');
            }, 5000);
        }
    };

    const onError = () => {
        console.log('Login Failed');
        setError("Google login failed.");
        setTimeout(() => {
            setError('');
        }, 5000)
    };

    return (
        <div>
            {error && <p className="account_error">{error}</p>}<br />
            {/*<button className="signup_google" onClick={handleGoogleSignup}>
                <img src={Google} alt="google" />
                 <FaGooglePlusG /> 
                <span>Continue With Google</span></button><br />*/}
            <div className="googlecontainer">
                <GoogleLogin
                    onSuccess={onSuccess}
                    onError={onError}
                    className="google_main_login" />

            </div>
        </div>
    )
}

export default GoogleSignup